import { render, staticRenderFns } from "./tableClassify.vue?vue&type=template&id=5fd2a1f4&scoped=true"
import script from "./tableClassify.vue?vue&type=script&lang=js"
export * from "./tableClassify.vue?vue&type=script&lang=js"
import style0 from "./tableClassify.vue?vue&type=style&index=0&id=5fd2a1f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2a1f4",
  null
  
)

export default component.exports